var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex"},_vm._l((_vm.value),function(index){return _c('ui-icon',_vm._b({key:index,class:_vm.disabled ? 'text-disabled' : 'text-yellow',attrs:{"name":"star"}},'ui-icon',_vm.$attrs,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }